import { supabase } from '../lib/supabase';
import { getVisitorId, getSessionId } from '../utils/tracking';

export const analyticsService = {
  /**
   * Tracks a public event securely along with session context.
   */
  trackEvent: async (slug, eventType, source = 'unknown', metadata = {}) => {
    try {
      const visitorId = getVisitorId();
      const sessionId = getSessionId();
      
      await supabase.rpc('track_card_event', {
        p_slug: slug,
        p_event_type: eventType,
        p_source: source,
        p_metadata: metadata,
        p_visitor_id: visitorId,
        p_session_id: sessionId
      });
    } catch (err) {
      console.error('Analytics tracking failed silently:', err);
    }
  },

  getDashboardStats: async (startDate, endDate, cardId = null) => {
    try {
      const { data, error } = await supabase.rpc('get_analytics_dashboard', {
        p_start_date: startDate.toISOString(),
        p_end_date: endDate.toISOString(),
        p_card_id: cardId
      });
      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Failed to fetch analytics:', err);
      return { summary: {}, trends: [] };
    }
  },

  getCardsPerformance: async (startDate, endDate) => {
    try {
      const { data, error } = await supabase.rpc('get_cards_performance', {
        p_start_date: startDate.toISOString(),
        p_end_date: endDate.toISOString()
      });
      if (error) throw error;
      return data || [];
    } catch (err) {
      console.error('Failed to fetch card performance:', err);
      return [];
    }
  },

  /**
   * Fetches the structured intelligence summary for future AI consumption.
   */
  getIntelligenceSummary: async (startDate, endDate) => {
    try {
      const { data, error } = await supabase.rpc('get_intelligence_summary', {
        p_start_date: startDate.toISOString(),
        p_end_date: endDate.toISOString()
      });
      if (error) throw error;
      return data;
    } catch (err) {
      console.error('Failed to fetch intelligence summary:', err);
      return null;
    }
  }
};